import { withClient } from './client';

/**
 * Opts the current browser in to tracking. Must run before `identify`/`register`
 * post sign-in — `initAnalytics` starts every session opted out, so calls made
 * before this one are silently ignored.
 */
export const optIn = (): void => {
  withClient((mixpanel) => mixpanel.opt_in_tracking());
};

/**
 * Opts the current browser out of tracking and clears its identity and super
 * properties. Call on sign-out so a shared browser reverts to the same
 * no-analytics state an anonymous visitor gets.
 */
export const optOut = (): void => {
  withClient((mixpanel) => mixpanel.opt_out_tracking());
};

/** Sets the Mixpanel distinct id for the current session. */
export const identify = (distinctId: string): void => {
  withClient((mixpanel) => mixpanel.identify(distinctId));
};

/** Registers super properties, attached to every event from now on. */
export const register = (properties: Record<string, string | number | boolean>): void => {
  withClient((mixpanel) => mixpanel.register(properties));
};
